<script>
import SearchResultsTab from '@maison/components/search/SearchResultsTab';
import PagePushRow from '@maison/components/organisms/PagePushRow';
import { TAB_SERVICES } from '@maison/helpers/search-helper';
import { algoliaTracking } from '@module/Algolia/resources/js/insights/helpers';
import { IndexNames } from '@module/Algolia/resources/js/search/AlgoliaSearch';
import searchResultsTabMixin from '@phoenix/mixins/searchResultsTabMixin';
import searchResultsTrackingMixin from '@maison/mixins/searchResultsTrackingMixin';
import { mapActions } from 'vuex';

export default {
  components: {
    SearchResultsTab,
    PagePushRow,
  },

  mixins: [searchResultsTabMixin, searchResultsTrackingMixin],

  data() {
    return {
      tab: TAB_SERVICES,
    };
  },

  methods: {
    ...mapActions('search', ['setHasInteractedWithResults']),

    onItemClick(item, index) {
      this.setHasInteractedWithResults();
      algoliaTracking(item, index, IndexNames.Articles);

      this.sendSearchClickTracking(this.query, item.link, index, 'service');
    },
  },
};
</script>

<template>
  <search-results-tab :tab="tab" :limit="limit" class="pt-base">
    <page-push-row :items="items" :cols="4" @on-item-click="onItemClick" />
  </search-results-tab>
</template>
